<!-- 表计读数列表 -->
<template>
  <div class="container containerBox">
      <!-- 头部筛选区 -->
      <div class="handle-box">
        <el-form :inline="true" :model="handleForm" class="demo-form-inline">
            <el-form-item :label="$t('household.selectRes')" prop="residenceOID">
                <cmp-build-select 
                    :buildRoom="buildRoom"
                    changeOnSelect
                    @listenBuildResult="listenBuildResult"></cmp-build-select>                   
            </el-form-item>
            <el-form-item label="表计序列号">
                <el-input v-model="handleForm.deviceSerial" placeholder="请输入表计序列号"></el-input>
            </el-form-item>
            <el-form-item label="在线状态">
                <el-select v-model="handleForm.status" clearable placeholder="请选择">
                    <el-option label="在线" :value="1"></el-option>
                    <el-option label="离线" :value="2"></el-option>
                </el-select>
            </el-form-item>
           <!-- <el-form-item label="开关机">
                <el-select v-model="handleForm.power_on" clearable placeholder="请选择">
                    <el-option label="开机" :value="1"></el-option>
                    <el-option label="关机" :value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="故障状态">
                <el-select v-model="handleForm.sys_status" clearable placeholder="请选择">
                    <el-option label="正常" :value="0"></el-option>
                    <el-option label="故障" :value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="模式">
                <el-select v-model="handleForm.factory_mode" clearable placeholder="请选择">
                    <el-option label="调试模式" :value="1"></el-option>
                    <el-option label="正常模式" :value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="计费模式">
                <el-select v-model="handleForm.fcu_in_counting" clearable placeholder="请选择">
                    <el-option label="允许计费" :value="1"></el-option>
                    <el-option label="停止计费" :value="0"></el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
            <!-- <el-form-item>
                <el-button type="primary" @click="onClearing">结算</el-button>
            </el-form-item> -->
            <div class="fr">
                <el-form-item>
                    <el-button type="primary" plain icon="el-icon-refresh" @click="onRefresh">刷新</el-button>
                </el-form-item>
            </div>
        </el-form>
      </div>
      <div style="margin:-15px 0 10px;">
            <el-alert class="tips-box" :closable="false" type="success" title="">
                <span class="tips-item">设备总数：{{devTip.total}}</span>&nbsp;&nbsp;
                <span class="tips-item" v-if="devTip.status>0">故障：{{devTip.status}}</span>&nbsp;&nbsp;
                <span class="tips-item" v-if="devTip.power>0">关机：{{devTip.power}}</span>
            </el-alert>
      </div>
      <!-- 表格区 -->
      <div class="tab-box">
        <el-tabs v-model="activeTable" type="card" @tab-click="handleClick">
            <el-tab-pane
                v-for="v in tabCard"
                :key="v.name"
                :label="v.label"
                :name="v.name"
            ></el-tab-pane>
        </el-tabs>
      </div>
      <!-- 温控器 -->
      <div v-show="activeTable === 'WKQ'">
          <cmp-wkq-table :tableData_WKQ="tableData_WKQ"></cmp-wkq-table>
      </div>

      <!-- 风柜 -->
      <div v-show="activeTable === 'FG'">
          <cmp-fg-table :tableData_FG="tableData_FG"></cmp-fg-table>
      </div>

      <!-- 热量表 -->
      <div v-show="activeTable === 'RLB'">
          <cmp-rlb-table :tableData_RLB="tableData_RLB"></cmp-rlb-table>
      </div>
<!-- 	<div class="block">
	      <span class="demonstration">完整功能</span>
	      <el-pagination
	        @size-change="handleSizeChange"
	        @current-change="handleCurrentChange"
	        :current-page="currentPage"
	        :page-sizes="[100, 200, 300, 400]"
	        :page-size="100"
	        layout="total, sizes, prev, pager, next, jumper"
	        :total="400">
	      </el-pagination>
	</div> -->
  </div>
</template>

<script>
import Service from '@/api/Service'

import CmpBuildSelect from '@/components/CmpBuildSelect/CmpBuildSelect'
import fmtDeviceData from './EquipmentInfo.js'
import CmpWkqTable from './CmpEquipmentTable/CmpWkqTable'
import CmpFgTable from './CmpEquipmentTable/CmpFgTable'
import CmpRlbTable from './CmpEquipmentTable/CmpRlbTable'

export default {
    name: "equipmentcontrol",
    inject: ["reload"],
    data() {
        return {
            // 选择房间组件
            buildRoom: {},
            // 搜索参数
            handleForm: {
                deviceSerial: '',
                status: '',
                power_on: '',
                sys_status: '',
                factory_mode: '',
                fcu_in_counting: '',
                moduleid: 0,
                page_num: 1,
                page_sum: 1000,
                is_house: false,
            },
            activeTable: '',
            tabCard: [],
            // 数据
            tableData_WKQ: [],  //  温控器列表
            tableData_FG: [],  //  当量风柜列表
            tableData_RLB: [],  //  热量表列表
        };
    },
    components: {
        CmpWkqTable,
        CmpFgTable,
        CmpRlbTable,
        CmpBuildSelect
    },
    computed: {
        devTip() {
            let total = this.tableData_WKQ.length + this.tableData_FG.length + this.tableData_RLB.length;
            let wkq_status = this.tableData_WKQ.filter(v=>{
                return v.sysStatusResult === "故障"
            })
            let wkq_linkStatus = this.tableData_WKQ.filter(v=>{
                return v.powerOn === "关机"
            })
            let fg_status = this.tableData_FG.filter(v=>{
                return v.sysStatusResult === "故障"
            })
            let fg_linkStatus = this.tableData_FG.filter(v=>{
                return v.settingPowerOn === "关机"
            })
            let status = wkq_status.length + fg_status.length;
            let power = wkq_linkStatus.length + fg_linkStatus.length;
            return {total, status, power }
        }   
    },
    created() {
        this.getReading();
    },
    methods: {
        
        // 获取表计当前读数
        async getReading() {
            let res = await Service.getnewTerminalcurrentreadingsbypid(this.handleForm);
            if(res) {
                let data = res.list === null ? [] : res.list;
                let meterInfo = fmtDeviceData(data);

                this.tableData_RLB = meterInfo.RLB;
                this.tableData_FG = meterInfo.FG;
                this.tableData_WKQ = meterInfo.WKQ;

                let tabCard = [];
                if(meterInfo.RLB.length>0) {
                    tabCard.push({
                        label: '热量表',
                        name: 'RLB'
                    })
                    
                    this.activeTable = 'RLB'
                }
                if(meterInfo.FG.length>0) {
                    tabCard.push({
                        label: '当量风柜',
                        name: 'FG'
                    })
                    
                    this.activeTable = 'FG'
                }
                if(meterInfo.WKQ.length>0) {
                    tabCard.push({
                        label: '温控器',
                        name: 'WKQ'
                    })
                    this.activeTable = 'WKQ'
                }
                // 倒叙
                this.tabCard = tabCard.reverse();
            }
        },
        // 最后一级房间确认信息
        listenBuildResult(data) {
            if(data.householdid === undefined) {
                // 建筑
                this.handleForm.is_house = false
            }else{
                // 房间
                this.handleForm.is_house = true
            }
            this.handleForm.moduleid = data.oid || 0;
        },
        // 查询
        onSubmit() {
            this.getReading()
        },
        // 刷新
        onRefresh() {
            this.reload();
        },
        // 结算
        onClearing() {
            this.$router.push("/ownerclose");
        },
        // 选择设备表计
        handleClick(tab, event) {
            if(!tab.active){
                this.activeTable = tab.name
            }
        },
        // 选择表计
        handleSelectionChange() {

        }
    }
};
</script>
<style lang='less' scoped>

</style>
